// src/components/Admin/AdminStores.js
"use client";

import { useEffect, useState } from "react";
import { Table, Button, Spinner } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import StoreFormModal from "./StoreFormModal";
import WalletChargeModal from "./WalletChargeModal";
import { Link, useNavigate } from "react-router-dom";
import PaginationBar from '../Pagination/PaginationBar';

const AdminStoresComp = () => {
	const navigate = useNavigate();
	const [stores, setStores] = useState([]);
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(true);

	const [page, setPage] = useState(1);
	const [perPage, setPerPage] = useState(20);
	const [totalPages, setTotalPages] = useState(1);
	const [total, setTotal] = useState(0);
	const [search, setSearch] = useState('');

	const [showFormModal, setShowFormModal] = useState(false);
	const [editStore, setEditStore] = useState(null);

	const [showChargeModal, setShowChargeModal] = useState(false);
	const [selectedStoreId, setSelectedStoreId] = useState(null);

	/*
	const fetchStores = async () => {
		try {
			const { data } = await api.get("/admin/stores");
			setStores(data.items ?? data);
		} catch (err) {
			toast.error("خطا در دریافت فروشگاه‌ها");
		} finally {
			setLoading(false);
		}
	};
	*/

	const fetchStores = async () => {
		try {
			setLoading(true);
			// ارسال پارامترها به بک‌اند مطابق با کدهای admin.service.ts
			const response = await api.get(`/admin/stores`, {
				params: { page, perPage, search }
			});
			
			// تنظیم مقادیر دریافتی از بک‌اند
			setStores(response.data.items || []);
			setTotalPages(response.data.totalPages || 1);
			setTotal(response.data.total || 0);
		} catch (error) {
			toast.error('خطا در دریافت لیست فروشگاه‌ها');
		} finally {
			setLoading(false);
		}
	};

	const fetchCategories = async () => {
		try {
			const { data } = await api.get("/merchant-categories?isActive=true");
			setCategories(data.items ?? data);
		} catch {
			toast.error("خطا در دریافت دسته محصولات");
		}
	};

	useEffect(() => {
		fetchStores();
		fetchCategories();
	}, [page, perPage]);

	const deleteStore = async (id) => {
		if (!window.confirm("آیا مطمئن هستید که می‌خواهید فروشگاه را حذف کنید؟")) return;
		try {
			await api.delete(`/admin/stores/${id}`);
			toast.success("فروشگاه حذف شد");
			fetchStores();
		} catch (err) {
			toast.error("خطا در حذف فروشگاه");
		}
	};

	if (loading) return <Spinner animation="border" className="d-block m-auto mt-5" />;

	return (
		<>
			<div className="mb-3">
				<Button
					variant="primary"
					onClick={() => {
						setEditStore(null);
						setShowFormModal(true);
					}}>
					افزودن فروشگاه جدید
				</Button>
			</div>

			<Table striped bordered hover responsive>
				<thead>
					<tr>
						<th>#</th>
						<th>نام فروشگاه</th>
						<th>شماره تلفن</th>
						<th>آدرس</th>
						<th>توضیحات</th>
						<th>مدیر</th>
						<th>موبایل مدیر</th>
						<th>دسته محصول</th>
						<th>مدیر الصاق شده</th>
						<th>وضعیت</th>
						<th>عملیات</th>
					</tr>
				</thead>
				<tbody>
					{stores.map((s, idx) => (
						<tr key={s.id}>
							<td>{idx + 1}</td>
							<td>{s.name}</td>
							<td>{s.phone}</td>
							<td>{s.address}</td>
							<td>{s.description}</td>
							<td>{s.ownerName}</td>
							<td>{s.ownerMobile}</td>
							<td>{s.storeCategories?.[0]?.category?.title || "-"}</td>
							<td>{s.users?.map(u => `#${u.id} ${u.name} ${u.family}`).join(" , ") || "-"} ({s.users?.length || 0})</td>
							<td>{s.status}</td>
							<td>
								{/* <Button
                  size="sm"
                  variant="success"
                  onClick={() => {
                    setSelectedStoreId(s.id);
                    setShowChargeModal(true);
                  }}
                >
                  شارژ کیف پول
                </Button> */}
								<Button
									size="sm"
									variant="warning"
									className="ms-2"
									onClick={() => {
										setEditStore(s);
										setShowFormModal(true);
									}}>
									ویرایش
								</Button>
								<Button size="sm" variant="danger" className="ms-2" onClick={() => deleteStore(s.id)}>
									حذف
								</Button>
								<Button
									size="sm"
									variant="info"
									className="ms-2"
									onClick={() => {
										navigate(`/admin/stores/${s.id}/requests`);
									}}>
									درخواست‌ها
								</Button>
							</td>
						</tr>
					))}
				</tbody>
			</Table>

			{!loading && stores.length > 0 && (
				<PaginationBar
					page={page}
					setPage={setPage}
					totalPages={totalPages}
					perPage={perPage}
					setPerPage={setPerPage}
				/>
			)}

			{/* مودال فرم */}
			<StoreFormModal show={showFormModal} onHide={() => setShowFormModal(false)} store={editStore} categories={categories} onSuccess={fetchStores} />

			{/* مودال شارژ */}
			<WalletChargeModal show={showChargeModal} onHide={() => setShowChargeModal(false)} targetType="STORE" targetId={selectedStoreId} onSuccess={fetchStores} />
		</>
	);
};

export default AdminStoresComp;
